import { createBrowserRouter, redirect } from 'react-router-dom';

import { getSession, store } from 'app/state';
import { DefaultLayout, StandaloneLayout } from 'app/layouts';
import { Account, Auth, Client, Confirmations, Country, Home, Offer, Profession, Profile, Report, Specialty, User } from 'app/modules';

export default createBrowserRouter([
  { path: '', element: <DefaultLayout />,
    loader: () => (getSession(store.getState()) ? null : redirect('/signin')),
    children: [
      ...Account.routes,
      ...Client.routes,
      ...Confirmations.routes,
      ...Country.routes,
      ...Home.routes,
      ...Offer.routes,
      ...Profession.routes,
      ...Profile.routes,
      ...Specialty.routes,
      ...Report.routes,
      ...User.routes,
    ],
  },
  { path: '', element: <StandaloneLayout />,
    loader: () => (getSession(store.getState()) ? redirect('/') : null),
    children: [
      ...Auth.routes,
    ],
  },
], {});
